import React from "react";
import styled from "styled-components";
import { Container, Row, Col } from "react-bootstrap";

import { Title, Button, Section, Box, Text, Input } from "../components/Core";

import PageWrapper from "../components/PageWrapper";
import Logo from "../components/Logo";
import imgBg from "../assets/image/jpeg/coming-soon-bg.jpg";

const BoxStyled = styled(Box)`
  background-image: url(${imgBg});
  min-height: 100vh;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const Footer = styled(Box)`
  justify-content: flex-end;
`;

const SocialList = styled.ul`
  display: flex;
  list-style: none;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  height: 100%;
  padding: 0;
  a {
    display: inline-block;
    color: #f7f7fb !important;
    font-size: 23px;
    transform: translateY(0);

    padding: 0 3px;
    margin: 0 12px;
    transition: all 0.4s ease-out;
    &:hover {
      transform: translateY(-3px);
      color: ${({ theme }) => theme.colors.primary} !important;
    }
    &:visited {
      text-decoration: none;
    }
  }
`;

const ComingSoon = () => {
  return (
    <>
      <PageWrapper>
        <BoxStyled>
          <Box>
            <Container className="text-center">
              <Row className="justify-content-center">
                <Col lg="10" xl="8">
                  <Box className="text-center" pt="40px">
                    <Logo white />
                  </Box>
                </Col>
              </Row>
            </Container>
          </Box>
          <Box>
            <Container className="text-center">
              <Row className="justify-content-center">
                <Col lg="10" xl="8">
                  <Section>
                    <div>
                      <Title color="light">
                        Future home of {" "}
                        <br className="d-none d-md-block" /> something great
                      </Title>
                      <Text color="lightShade">
                      </Text>
                    </div>
                    <div className="mt-5">
                      <Text color="lightShade">
                        Stay tuned, offering portfolio in progress.
                      </Text>
                    </div>
                  </Section>
                </Col>
              </Row>
            </Container>
          </Box>
        </BoxStyled>
      </PageWrapper>
    </>
  );
};
export default ComingSoon;
